import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteMessage",
  tabindex: "-1",
  "aria-labelledby": "deleteMessage",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteGroup"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "text-center my-5 text-break" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_9 = {
  class: "modal fade",
  id: "deleteGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteGroupSuccess",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "modal-dialog" }
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = { class: "modal-header" }
const _hoisted_13 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteGroup"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_15 = { class: "text-center my-5 text-break" }
const _hoisted_16 = { class: "modal-footer d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'

import { computed, PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object,
  CancelSending: {
    type: Function as PropType<() => void | undefined>,
  },
  deleteFailed: Boolean,
  messageCode: {
    type: String,
    default: '',
  },
  loadingDelete: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const renderError = computed(() => {
  switch (props.messageCode) {
    case 'VALIDATE_CANCELLATION_FAILURE':
      return translate('OE65cancelFailed')
    default:
      return translate('OE65deleteFailed')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE65titleCancel')), 1),
              _hoisted_6
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)('message')) + "「" + _toDisplayString(__props.data?.title) + "」" + _toDisplayString(_unref(translate)('OE65textCancel')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('OE65buttonCancel'),
                type: 'secondary',
                className: 'fw-bold',
                onClick: __props.CancelSending,
                loading: __props.loadingDelete,
                disabled: __props.loadingDelete
              }, null, 8, ["title", "onClick", "loading", "disabled"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h5", _hoisted_13, _toDisplayString(_unref(translate)('OE65titleCancel')), 1),
            _hoisted_14
          ]),
          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(translate)('message')) + "「" + _toDisplayString(__props.data?.title) + "」" + _toDisplayString(__props.deleteFailed ? _unref(renderError) : _unref(translate)('OE65deleteSuccess')), 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})